import { RetentionCampaignsService } from '@services/retention-campaigns.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject, Observable, merge, combineLatest } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CommunicationsService } from '@services/communications.service';
import { takeUntil } from 'rxjs/operators';
import { MailjetEmailTemplate } from '@models/communications/mailjet-email-template.model';
import { ServiceProviderService } from '@services/service-provider.service';
import { ServiceTemplatesService } from '@services/service-templates.service';
import { ServiceOrProductType, ServiceOrProduct } from '@models/communications/service-or-product.model';
import { ClinicProductsService } from '@services/clinic-products.service';
import * as moment from 'moment';
@Component({
  selector: 'app-edit-email-templates',
  templateUrl: './edit-email-templates.component.html',
  styleUrls: ['./edit-email-templates.component.less'],
})
export class EditEmailTemplatesComponent implements OnInit, OnDestroy {
  private unsub: Subject<void> = new Subject<void>();
  loading = false;
  actionType = 'Create';
  saveBtnName = 'Create';
  form: FormGroup;
  campaignStatuses = ['Draft', 'Active', 'Suspended'];
  timePeriodUnits: string[] = ['minutes', 'hours', 'days', 'weeks', 'months'];
  lessMoreTypes: string[] = ['less than', 'more than'];
  firstLastTypes: string[] = ['first', 'last'];
  beforeAfterTypes: string[] = ['before', 'after'];
  hasNotTypes: string[] = ['has', 'has not'];
  numberOfDays: string[] = ['number of days'];
  emailTemplates: MailjetEmailTemplate[] = [];
  serviceProviders = [];
  focus$ = new Subject<string>();
  allServicesOrProducts: ServiceOrProduct[] = [];
  selectedServicesOrProducts: ServiceOrProduct[] = [];
  id = 0;
  submitted = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private communicationsService: CommunicationsService,
    private providerService: ServiceProviderService,
    private serviceTemplatesService: ServiceTemplatesService,
    private productsService: ClinicProductsService,
    private retentionCampaignsService: RetentionCampaignsService
  ) {}

  ngOnInit() {
    this.initForm();
    this.route.params.pipe(takeUntil(this.unsub)).subscribe((params) => {
      // if (params['templateName']) {
      //   this.form.controls['name'].setValue(params['templateName']);
      // }
      if (params['id'] !== '_') {
        this.actionType = 'Edit';
        this.saveBtnName = 'Save';
        this.id = +params['id'];
        // this.populateTemplateValues(this.id);
      } else {
      }
    });
  }
  populateTemplateValues(templateId: number) {
    this.loading = true;
    this.communicationsService
      .getEmailTemplateDetails(templateId)
      .pipe(takeUntil(this.unsub))
      .subscribe((template) => {
        if (template == null) {
          this.loading = false;
          return;
        }
        this.form.controls['htmlTemplate'].setValue(template.htmlTemplate);
        this.loading = false;
      });
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      htmlTemplate: new FormControl('', Validators.required),
    });
  }

  saveChanges() {
    this.submitted = true;
  }

  cancelUpdate() {
    this.communicationsService.refreshRequired = false;
    this.communicationsService.communicationsSettingsUpdated.next();

    this.router.navigate(['/management/communication/email-templates/', { outlets: { 'action-panel': null } }]);
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
